import { styled, css, Box } from '@mui/material'
import { PromotionsDetailsStyles } from './PromotionsDetails.types'
import Text from '../Text'

export const PromotionsDetailsWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['hasImage'].includes(String(prop))
})<PromotionsDetailsStyles>(
  () => css`
    display: table;
    align-items: center;
    justify-content: flex-start;
    min-height: 18px;
    line-height: 1.2em;
    gap: 8px;
  `
)

export const PromotionsDetailsRow = styled(Box, {
  shouldForwardProp: (prop) => !['hasImage'].includes(String(prop))
})<PromotionsDetailsStyles>(
  () => css`
    display: table-row;
  `
)

export const PromotionsDetailsCell = styled(Box, {
  shouldForwardProp: (prop) => !['hasImage'].includes(String(prop))
})<PromotionsDetailsStyles>(
  () => css`
    display: table-cell;
    padding-top: 4px;
    padding-bottom: 4px;
    &:first-of-type {
      padding-right: 8px;
    }
  `
)

export const BuyLabel = styled(Text)(
  () => css`
    display: inline;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `
)

export const DiscountLabel = styled(Text)(
  () => css`
    display: inline;
    padding-left: 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
  `
)

export const SavingLabel = styled(Text)(
  ({ theme }) => css`
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    border-left: 1px solid ${theme.palette.grey[400]};
    padding-left: 8px;
  `
)
